import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
export default function NFTMediaContainer(t0) {
  const $ = _c(5);
  const {
    children,
    className,
    textCenter: t1
  } = t0;
  const textCenter = t1 === undefined ? false : t1;
  const t2 = `tw-flex tw-w-full tw-items-center tw-justify-center tw-bg-iron-900 tw-p-0 ${textCenter ? "tw-text-center" : ""} ${className ?? ""}`;
  let t3;
  if ($[0] !== t2) {
    t3 = t2.trim();
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}